export default __webpack_public_path__ + "static/media/volkswagen.cfd39c6f.png";